import { render, staticRenderFns } from "./SOV2.vue?vue&type=template&id=31f06493&scoped=true"
import script from "./SOV2.vue?vue&type=script&lang=js"
export * from "./SOV2.vue?vue&type=script&lang=js"
import style0 from "./SOV2.vue?vue&type=style&index=0&id=31f06493&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f06493",
  null
  
)

export default component.exports